/**
 * @module Honestybox
 */
class Honestybox {

    /**
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {
        this._element = element;
        this._options = Object.assign(Honestybox.options, options);
        this._cookielinks = Array.from(element.querySelectorAll('[data-setcookie="true"]'));

        this._setCookieAndRedirect = this._setCookieAndRedirect.bind(this);
        this.load();
    }


    /**
     * Base options
     */
    static get options() {
        return {
            cookiename: 'honestybox'
        };
    }


    /**
     * Construct module
     */
    load() {
        this._cookielinks.forEach(elem => {
            elem.addEventListener('click', this._setCookieAndRedirect);
        });
    }

    /**
     * Click event handler
     * @param {object} e - click event object
     * @private
     */
    _setCookieAndRedirect(e) {
        e.preventDefault();

        document.cookie = `${this._options.cookiename}=true; path=/`;
        document.location = e.target.href;
    }

}

export default Honestybox;
